<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <div class="pb-2">
                        <p>
                            <b>Customer:</b> {{order.registeredCompanyName}}
                        </p>
                        <!--                        <p v-if="order.customerBranch">-->
                        <!--                            Branch: {{order.customerBranch}}-->
                        <!--                        </p>-->
                        <p>
                            <b>Order Date:</b> {{order.insertedOn}}
                        </p>
                        <p>
                            <b>Order Type:</b> {{order.orderType}}
                        </p>
                        <p>
                            <b>Order Status:</b> {{order.description}}
                        </p>
                        <!--                        <p v-if="order.placedBy">-->
                        <!--                            Placed By: {{order.placedBy}} (#{{order.placedByUserId}})-->
                        <!--                        </p>-->
                        <p v-if="order.expectedDeliveryDate !== null && order.expectedDeliveryDate !== undefined">
                            <b>Expected Date Of Delivery:</b> {{order.expectedDeliveryDate}}
                        </p>
                    </div>
                    <div class="card border border-secondary mb-3">
                        <div class="card-body text-secondary">
                            <div class="row">
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Billing Address</h5>
                                    <p v-if="!loadingBillingAddress">
                                        <span v-if="billingAddress">
                                            {{ billingAddress.siteName }}<br>
                                            {{ billingAddress.streetAddress }}<br>
                                            {{ billingAddress.city }} <br>
                                            {{ billingAddress.province }} <br>
                                            {{ billingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                                <span v-else>
                                            No billing address found.
                                        </span>
                                    </p>
                                    <p v-if="loadingBillingAddress">Loading...</p>
                                </div>
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Shipping Address</h5>
                                    <p v-if="!loadingBillingAddress">
                                        <span v-if="shippingAddress">
                                            {{ shippingAddress.siteName }}<br>
                                            {{ shippingAddress.streetAddress }}<br>
                                            {{ shippingAddress.city }} <br>
                                            {{ shippingAddress.province }} <br>
                                            {{ shippingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                        <span v-else>
                                            No shipping address found.
                                        </span>
                                    </p>
                                    <p v-if="loadingBillingAddress">Loading...</p>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="card border border-secondary pt-2">
                        <div class="card-body text-secondary">
                            <h5 class="card-title text-secondary">Items Ordered</h5>
                            <order-items-table
                                    :orderId="orderId"
                                    :orderTotal="orderGrandTotal"></order-items-table>
                        </div>
                    </div>
                    <br>
                    <div class="form-group">
                        <label>Vehicle</label>
                        <div class="text-danger" v-if="scheduleOrder.vehicleId.hasError">
                            {{scheduleOrder.vehicleId.errorMessage}}
                        </div>
                        <bootstrap-select  :selectOptions="vehicles" :selectedOption="scheduleOrder.vehicleId.value" :elementId="'vehicleSelect'"
                                           :returnSelectedOptionText="true"
                                           @changeSelect="onVehicleSelect"></bootstrap-select>
                    </div>
                    <div class="form-group">
                        <label>Driver</label>
                        <div class="text-danger" v-if="scheduleOrder.driverId.hasError">
                            {{scheduleOrder.driverId.errorMessage}}
                        </div>
                        <bootstrap-select  :selectOptions="drivers" :selectedOption="scheduleOrder.driverId.value" :elementId="'driverSelect'"
                                           :returnSelectedOptionText="true"
                                           @changeSelect="onDriverSelect"></bootstrap-select>
                    </div>
                    <div class="form-group">
                        <label>Date of Departure</label>
                        <div class="text-danger" v-if="scheduleOrder.dateOfDeparture.hasError">
                            {{scheduleOrder.dateOfDeparture.errorMessage}}
                        </div>
                        <date-picker :format="'DD/MM/YYYY'" :elementId="'dateOfDepartureSelect'" :date="scheduleOrder.dateOfDeparture.value"
                                     :initialiseDate="initialiseDate"
                                     @dateChange="onDateOfDepartureSelect"></date-picker>
                    </div>
                    <div class="form-group">
                        <label>Expected Date of Delivery</label>
                        <div class="text-danger" v-if="scheduleOrder.expectedDateOfDelivery.hasError">
                            {{scheduleOrder.expectedDateOfDelivery.errorMessage}}
                        </div>
                        <date-picker :format="'DD/MM/YYYY'" :elementId="'expectedDateOfDeliverySelect'" :date="scheduleOrder.expectedDateOfDelivery.value"
                                     :initialiseDate="initialiseExpectedDate"
                                     @dateChange="onExpectedDateOfDeliverySelect"></date-picker>
                    </div>
                    <div class="form-group">
                        <label for="reasonInput">
                            SBO
                        </label>
                        <div class="text-danger" v-if="scheduleOrder.sbo.hasError">
                            {{scheduleOrder.sbo.errorMessage}}
                        </div>
                        <input type="text" class="form-control" v-model="scheduleOrder.sbo.value"/>
                    </div>
                    <button class="btn btn-primary" @click="validateScheduleOrderForDeliverySubmit" :disabled="schedulingOrder">Schedule</button>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
    
    <success-modal
        :modalHeading="successModal.modalHeading"
        :elementId="'scheduleOrderSuccessModal'"
        :modalMessage="successModal.modalMessage"
        :showModal="successModal.showModal"
        @okClicked="onSuccessModalOkClick">
        
    </success-modal>
    
</div>
